import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExploreService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getExploreTab(tabEnum: number, workSpaceId: string, pageNumber: number, pageSize) {
    return this.http.get(
      `${this.baseUrl}/api/explore?_page=${pageNumber}&_limit=${pageSize}&workSpaceId=${workSpaceId}&tabId=${tabEnum}`,
    );
  }

  deleteAsset(assetId) {
    return this.http.delete(`${this.baseUrl}/api/explore/${assetId}`);
  }

  editAsset(assetId, newAsset) {
    return this.http.put(`${this.baseUrl}/api/explore/${assetId}`, newAsset);
  }
}
